import * as React from "react";
import { observer } from "mobx-react";
import { Card, Button, Input, Form } from "antd";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { ButtonsRow } from "Components/Form/ButtonsRow";
import { UserSelection } from "Components/Form/UserSelection";

interface SearchFilesFormProps extends WithTranslation {
  onSubmit: (values: API_DocSearchReq) => void;
  onCancel?: () => void;
  loading: boolean;
}

export const SearchFilesForm = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<SearchFilesFormProps> {
      handleSearchSubmit = (values: API_DocSearchReq) => {
        this.props.onSubmit(values);
      };

      render() {
        const { t } = this.props;
        return (
          <Form
            onFinish={this.handleSearchSubmit}
            labelCol={{ span: 6 }}
            colon={false}
            className="qa-form ant-form-item-grey-label"
            layout="horizontal"
          >
            <Card variant="outlined" styles={{ body: { padding: "24px 0" } }}>
              <Form.Item label={t("Filename")} name="fileName">
                <Input />
              </Form.Item>
              <Form.Item label={t("Description")} name="description">
                <Input />
              </Form.Item>
              <Form.Item label={t("Foldername")} name="folderName">
                <Input />
              </Form.Item>
              <Form.Item label={t("Index")} name="index">
                <Input />
              </Form.Item>
              <Form.Item label={t("File owner")} name="ownerId">
                <UserSelection />
              </Form.Item>
            </Card>
            <ButtonsRow justify="space-between" align="middle">
              <Button loading={this.props.loading} type="primary" htmlType="submit" style={{ fontSize: "15px" }}>
                {t("Search")}
              </Button>
            </ButtonsRow>
          </Form>
        );
      }
    }
  )
);
